import React from 'react'
import DatePicker from 'react-datepicker'

import styled from 'styled-components'
import { defaultInputStyles } from 'uikit/styles/theme'

import 'react-datepicker/dist/react-datepicker.css'

import cancelIcon from '../../../../assets/icons/cancel.svg'
import rightArrowIcon from '../../../../assets/icons/arrow-right.svg'
import leftArrowIcon from '../../../../assets/icons/arrow-left.svg'

const Wrapper = styled.div`
.tan-datepicker-wrapper {
  display: inline
}

.react-datepicker {
  font-family: inherit;
  font-size: inherit;
  background-color: #fff;
  color: inherit;
  border: 1px solid var(--color-gallery);
  border-radius: $datepicker__border-radius;
  position: relative;
}

.react-datepicker__triangle {
  border-bottom-color: var(--color-white) !important;

  :before {
    border-bottom-color: var(--color-gallery) !important;
  }
}

.react-datepicker-popper[data-placement^="bottom"] {
  .react-datepicker__triangle {
    margin-right: 257px !important;
  }
}

.react-datepicker__month-container {
  padding: 14px;
}

.react-datepicker__input-container input {
  ${defaultInputStyles}
  font-size: 16px;
  @media (min-width: 768px) {
    font-size: 14px;
  }
  &::placeholder {
      color: var(--color-gray);
    }
  }

.react-datepicker__header {
  background-color: var(--color-white);
  border-bottom: 0;
}

.react-datepicker__navigation {
  margin-top: 13px;
  width: 20px;
  height: 20px;
  border: none;

  &--previous {
    background: url(${leftArrowIcon});
    background-repeat: no-repeat;
    background-size: cover;
    margin-left: 13px;
  }

  &--next {
    background: url(${rightArrowIcon});
    background-repeat: no-repeat;
    background-size: cover;
    margin-right: 13px;
  }
}

.react-datepicker__current-month {
  font-size: 18px;
  font-weight: 600;
}
 
.react-datepicker__day-names {
  margin-top: 15px;
  font-weight: 600;
}

.react-datepicker__day-name {
  margin: 0;
  width: 38px;
  line-height: 2rem;
}

.react-datepicker__month {
  margin-top: 0;
}

.react-datepicker__day,
.react-datepicker__month-text,
.react-datepicker__quarter-text,
.react-datepicker__year-text {
  cursor: pointer;
  color: var(--color-tuatara);
  border-radius: 0;

  margin: 0;
  border: 0;
  outline: 1px solid var(--color-gallery) !important;
  margin-top: 1px;
  margin-left: 1px;

  width: 38px;
  height: 37px;
  padding: 4px 0px 0px 0px;
  text-align: center;

  &--today {
    outline-color: var(--color-chino) !important;
    background: var(--color-chino);
    color: var(--color-white);
    font-weight: 600;
  }

  &--outside-month {
    visibility: hidden
  }

  &--highlighted {
    background-color: var(--color-st-tropaz);
    color: #fff;

    &:hover {
      background-color: var(--color-st-tropaz);
    }

    &-custom-1 {
      color: magenta;
    }

    &-custom-2 {
      color: green;
    }
  }

  &--selected,
  &--in-selecting-range,
  &--in-range {
    background-color: var(--color-st-tropaz);
    outline-color: var(--color-st-tropaz) !important;
    color: var(--color-white);

    font-weight: 600; 

    &:hover {
      background-color: var(--color-st-tropaz);
    }
  }

  &:hover {
    border-radius: 0;
    background-color: var(--color-tussock);
    outline-color: var(--color-tussock) !important;
  }

  &--keyboard-selected {
    border-radius: 0;
    background-color: var(--color-st-tropaz);

    &:hover {
      background-color: var(--color-st-tropaz);
    }
  }

  &--in-selecting-range:not(&--in-range) {
    background-color: rgba(var(--color-st-tropaz), 0.5);
  }

  &--in-range:not(&--in-selecting-range) {
    .react-datepicker__month--selecting-range & {
      background-color: $datepicker__background-color;
      color: $datepicker__text-color;
    }
  }

  &--disabled {
    cursor: default;
    color: var(--color-silver);

    &:hover {
      background-color: transparent;
      outline-color: var(--color-gallery) !important;
    }
  }
}

.react-datepicker__close-icon {
  cursor: pointer;
  background-color: transparent;
  border: 0;
  outline: 0;
  padding: 0;
  position: absolute;
  top: -2px;
  right: 8px;
  height: 100%;
  display: table-cell;
  vertical-align: middle;

  :after {
    cursor: pointer;
    background-color: transparent;
    color: var(--color-gray);
    font-weight: 250;
    font-size: 30px;

    content: background-image: url(${cancelIcon});
  }

  :hover:after {
    transition: 150ms;
    color: var(--color-black);
  }
}
`

const CustomInputWrapper = styled.div`
  * {
    cursor: pointer;
  }

  /* These classes are a hack to get close to the behaviour of the other input fields:
     Show the validation status with the border color when the field is not hovered or 
     selected */
  .ok:not(:hover):not(:focus) {
    border-color: var(--color-chelsea-cucumber) !important;
  }

  .error:not(:hover):not(:focus) {
    border-color: var(--color-crimson) !important;
  }

  .react-datepicker-custom-input-icon {
    position: absolute;
    top: 11px;
    right: 12px;
    color: var(--color-gray);

    :hover {
      transition: 150ms;
      color: var(--color-black);
    }
  }
`

import Icon from '../Icon'

const inputClassName = status => {
  switch (status) {
    case 'ok':
      return 'ok'
    case 'error':
      return 'error'
    default:
      return undefined
  }
}

const CustomInput_ = ({ value, onClick, status, placeholderText }, ref) => (
  <CustomInputWrapper onClick={onClick}>
    <input
      ref={ref}
      readOnly
      value={value}
      className={inputClassName(status)}
      placeholder={placeholderText}
    />
    {!value && <Icon icon="arrow-down" className="react-datepicker-custom-input-icon" />}
  </CustomInputWrapper>
)

const CustomInput = React.forwardRef(CustomInput_)

const Datepicker = ({ placeholderText, status, ...datePickerProps }) => (
  <Wrapper>
    <DatePicker
      wrapperClassName="tan-datepicker-wrapper"
      isClearable
      popperPlacement="bottom-start"
      popperModifiers={{
        offset: {
          enabled: true,
          offset: '5, 10',
        },
        flip: {
          enabled: false,
        },
      }}
      disabledKeyboardNavigation
      customInput={<CustomInput placeholderText={placeholderText} status={status} />}
      {...datePickerProps}
    />
  </Wrapper>
)

export default Datepicker
